import React from 'react';
import { Modal, ModalFuncProps, ModalProps } from 'antd';
import { dataTestIdFromTitle } from 'vl-common/src/utils';

type InfoModalProps = ModalProps;

export const InfoModal = ({ onOk, ...rest }: InfoModalProps) => (
  <Modal
    centered
    onOk={onOk}
    onCancel={onOk}
    cancelButtonProps={{ style: { display: 'none' } }}
    {...rest}
    title={rest.title && <div data-testid={dataTestIdFromTitle(rest.title)}>{rest.title}</div>}
  />
);

export const infoModal = ({ ...otherProps }: ModalFuncProps) =>
  Modal.info({
    ...otherProps,
    ...(otherProps.title && {
      title: <div data-testid={dataTestIdFromTitle(otherProps.title)}>{otherProps.title}</div>
    })
  });
